import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, take, map } from 'rxjs';
import { PermissaoService } from '../services/permissao/permissao.service';
import { ModuloPermissaoDashboard } from '../models/dashboard/modulo-permissao.model';

/**
 * Guard funcional que verifica permissao por rota.
 * Le o campo `data.permissao` da rota e verifica no PermissaoService.
 * Espera as permissoes carregarem antes de decidir (evita race condition).
 */
export const permissionGuard: CanActivateFn = (route, state) => {
  const permissaoService = inject(PermissaoService);
  const router = inject(Router);

  const campoPermissao = route.data['permissao'] as keyof ModuloPermissaoDashboard | undefined;
  // Telas que agregam varios modulos (ex.: /relatorios, com uma janela por
  // relatorio) declaram `permissoes`: basta ter UMA delas para entrar, e o
  // proprio componente esconde o que a pessoa nao pode ver.
  const camposAlternativos = route.data['permissoes'] as (keyof ModuloPermissaoDashboard)[] | undefined;

  // Se a rota nao define permissao, permite acesso
  if (!campoPermissao && !camposAlternativos?.length) return true;

  return permissaoService.aguardarCarregamento().pipe(
    filter(carregado => carregado),
    take(1),
    map(() => {
      const permitido = campoPermissao
        ? permissaoService.temPermissao(campoPermissao)
        : camposAlternativos!.some(campo => permissaoService.temPermissao(campo));
      if (permitido) {
        return true;
      }
      return router.createUrlTree(['/sem-permissao']);
    })
  );
};
